import  { useState, useEffect } from "react";
import {Link} from "react-scroll"

function Navbar() {
    const [navActive, setNavActive] = useState(false);

    /* Open the Nav */
    const toggleNav = () => {
        setNavActive(!navActive);
    };
    
    /* Close the Nav */
    const closeMenu = () => {
        setNavActive(false);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 500) {
                closeMenu;
            }
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (window.innerWidth <= 1200) {
            closeMenu;
        }
    }, []);

    return (
        <nav className={`navbar ${navActive ? "active" : ""}`}>
            <a 
                className={`nav__hamburger ${navActive ? "active" : ""}`}
                onClick={toggleNav}>
                <span className="nav__hamburger__line"></span>
                <span className="nav__hamburger__line"></span>
                <span className="nav__hamburger__line"></span>
            </a>
            <div className={`navbar--items ${navActive ? "active" : ""}`}>
                <ul>
                    <li>
                        <Link onClick={closeMenu} activeClass="navbar--active--content"
                        spy={true} 
                        smooth={true}
                        offset={-70}
                        duration={500}
                        to="heroSection"
                        className="navbar--content">
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link onClick={closeMenu} activeClass="navbar--active--content"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        to="MyPortfolio"
                        className="navbar--content">
                            Projects
                        </Link>
                    </li>
                    <li>
                        <Link onClick={closeMenu} activeClass="navbar--active--content"
                        spy={true} 
                        smooth={true}
                        offset={-70}
                        duration={500}
                        to="AboutMe"
                        className="navbar--content">
                            About Me
                        </Link>
                    </li>
                    <li>
                        <Link onClick={closeMenu} activeClass="navbar--active--content"
                        spy={true}
                        smooth={true}
                        offset={-70}
                        duration={500}
                        to="mySkills"
                        className="navbar--content">
                            Skills
                        </Link>
                    </li>
                    {/* <li>
                        <Link onClick={closeMenu} activeClass="navbar--active--content"
                        spy={true} 
                        smooth={true}
                        offset={-70}
                        duration={500}
                        to="Testimonials"
                        className="navbar--content">
                            Testimonials
                        </Link>
                    </li> */}

                    {/* <li>
                        <a href="/Aparna_Anand_Resume.pdf" target="_blank" rel="noopener noreferrer" className="navbar--content">
                            Resume
                        </a>
                    </li> */}
                    <li>
                        <a
                            href="https://www.linkedin.com/in/aparna-anand-23b1b9233"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="navbar--content"
                        >
                            LinkedIn
                        </a>
                    </li>
                </ul>

            </div>
            <Link onClick={closeMenu} activeClass="navbar--active--content"
            spy={true} 
            smooth={true}
            offset={-70}
            duration={500}
            to="Contact"
            className="btn btn-outline-primary">
                Contact Me
            </Link>
        </nav>
    );
}

export default Navbar;